module.exports = __webpack_public_path__ + "static/media/certificate_01.ac157613.jpg";